var _defs, _ellipse, _ellipse2, _line, _ellipse3, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew281({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 8,
    cy: 3.38,
    rx: 2.46,
    ry: 2.43
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 13.81,
    cy: 13.87,
    rx: 1.19,
    ry: 1.18
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8.95,
    y1: 5.53,
    x2: 13.22,
    y2: 12.85
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 2.19,
    cy: 13.87,
    rx: 1.19,
    ry: 1.18
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 7.05,
    y1: 5.53,
    x2: 2.78,
    y2: 12.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew281);
export default __webpack_public_path__ + "static/media/Symbolpack_New_281.38b95ec6706193863d02d31b382f5503.svg";
export { ForwardRef as ReactComponent };